<template>
    <div id="reports_wrapper" class="mt-6 pt-2">

        <div class="mt-12 mb-2 px-4">
            <div class="d-block sansation info--text"><h2>Reports</h2></div>

            <div class="d-block">
                <v-radio-group row
                    v-model="show_report">
                    <v-radio
                        label="No Interest Buyers"
                        value="no_interest"
                        color="primary darken-1">
                    </v-radio>

                    <v-radio
                        label="Search Buyers"
                        value="search_buyers"
                        color="primary darken-1">
                    </v-radio>

                </v-radio-group>
            </div>
        </div>

        <NoInterestBuyers
            v-if="show_report == 'no_interest'"
            @triggerUserFeedback="triggerUserFeedback" />

        <SearchBuyers 
            v-if="show_report == 'search_buyers'"
            @triggerUserFeedback="triggerUserFeedback" />
    </div>
</template>

<script>
    import NoInterestBuyers from './reports/NoInterestBuyers'
    import SearchBuyers from './reports/SearchBuyers'

    export default {
        components: {
            SearchBuyers,
            NoInterestBuyers,
        },

        data: () => ({

            show_report: 'search_buyers'
        }),

        created () {
            document.title = `Reports`;
        },

        methods: {
            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green' ) {
                this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color );
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #reports_wrapper {
        /* width: 100%; */
        margin: 0 auto;
        padding: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/Reports.vue